import { render, staticRenderFns } from "./AllocationCarEntry.vue?vue&type=template&id=e91ff4b8&"
import script from "./AllocationCarEntry.vue?vue&type=script&lang=js&"
export * from "./AllocationCarEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports